import React from 'react';
import { NotFound } from 'modules/core/components/NotFound';
import { useSigninProps } from 'modules/core/components/NotFound/hooks/useSignInProps';

export const InviteNotFound: React.FC = () => {
  const signInProps = useSigninProps();
  return <NotFound {...signInProps} />;
};
